<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Christine Coleman, a University of Auckland graduate, practiced optometry in both Australia and New Zealand. Her other accomplishments include being a violinist with the New Zealand National Youth Orchestra, a singer with the Hamilton Operatic Society, an actress with the Mairangi Players, as well as a creditable pianist and bagpiper. Christine is a prolific short story writer and lives in Auckland with her husband, Brian.</p><br/>
<p style="text-align: center;"><img alt="1" src="media/1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6715d068